/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AggregatedMetricsResponse extends models.AggregateMetricsBase {
    getFixupPrototypeFunction() { return AggregatedMetricsResponse.fixupPrototype; }

    static newInstance(model: Partial<AggregatedMetricsResponse>): AggregatedMetricsResponse {
        let obj = Object.assign(new AggregatedMetricsResponse(), model);
        AggregatedMetricsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AggregatedMetricsResponse>): AggregatedMetricsResponse {
        if (!model) return null;
        return AggregatedMetricsResponse.newInstance(<AggregatedMetricsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AggregatedMetricsResponse) {
        if (!obj) return;

        models.AggregatedMetricsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AggregatedMetricsResponse): boolean {
        if (models.AggregateMetricsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AggregatedMetricsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.quantity === undefined) {
            this.quantity = 0;
        }
        if (this.timestamps) {
            for (let i = 0; i < this.timestamps.length; i++) {
                let val = this.timestamps[i];
                if (typeof val === "string") {
                    this.timestamps[i] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * Service account identifier
     */
    service_account_id: string;

    /**
     * Quantity
     */
    quantity: number;

    /**
     * timestamps
     */
    timestamps: Array<Date>;

    /**
     * List of metric values
     */
    values: Array<number>;

}
